import merge from 'lodash.merge';

const inlineEditable = (el, options = {}) => {

  options = merge({
    type: 'text',
    target: el,
  }, options);

  const targetEl = options.target;
  let isEditing = false;
  let currentValue = targetEl.text().trim();
  let inputEl = null;
  let controlsEl = null;

  const init = () => {

    targetEl.html(`
      <div class="inline-editing">
        <div class="inline-editing__input"></div>
        <div class="inline-editing__controls"></div>
      </div>`);

    inputEl = targetEl.find('.inline-editing__input');
    controlsEl = targetEl.find('.inline-editing__controls');

    setInactive();

  };

  const showError = errorMessage => {

    let errorEl = inputEl.find('.inline-editing-error');

    if(errorEl.length > 0) {
      errorEl.text(errorMessage);
    } else {
      inputEl.find('.inline-editing-input').after(`<div class="inline-editing-error">${errorMessage}</div>`);
    }

  };

  const setActive = () => {

    inputEl.html(`<input type="text" placeholder="${currentValue}" value="${currentValue}" class="inline-editing-input" required />`);
    controlsEl.html(`<button class="inline-editing-accept"><i class="far fa-check-circle"></i></button>
          <button class="inline-editing-cancel"><i class="far fa-times-circle"></i></button>`);

    const inlineEditingInput = targetEl.find('.inline-editing-input');
    const inlineEditingAccept = targetEl.find('.inline-editing-accept');
    const inlineEditingCancel = targetEl.find('.inline-editing-cancel');

    inlineEditingCancel.on('click', () => {
      setInactive();
      isEditing = false;
    });

    inlineEditingAccept.on('click', () => {

      const value = inlineEditingInput.val().trim();
      let hasError = false;
      if(inlineEditingInput.attr('required') && value.length === 0) {

        showError('Please fill out this field');
        hasError = true;
      }

      if(!hasError) {

        currentValue = value;
        setInactive();

        if(typeof options.onValidSubmission === 'function') {
          options.onValidSubmission(value);
        }
      }

    });

  };

  const setInactive = () => {

    inputEl.html(`${currentValue}`);
    controlsEl.html(`<button class="inline-editing-edit"><i class="far fa-edit"></i></button>`);

    const triggerEl = targetEl.find('.inline-editing-edit');

    $(triggerEl).on('click', e => {

      if(isEditing) return;
      setActive();

    });

  };

  init();

};

export default inlineEditable;
